module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "list-group"
  }, [_c('router-link', {
    staticClass: "list-group-item list-group-item-action active",
    attrs: {
      "to": '/admin/account-settings/set-up-google2fa'
    }
  }, [_vm._v("\n          Set Up Google2FA\n        ")])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    staticClass: "fa fa-gear"
  }), _vm._v(" Account Settings\n    ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-573c7b8a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/accountSettings/Index.vue
// module id = 908
// module chunks = 0